import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from './auth.service';

declare var _: any;
@Injectable()
export class RoleGuardService implements CanActivate {

  constructor(public auth: AuthService, public router: Router) { }

  canActivate(route: ActivatedRouteSnapshot): boolean {

    // this will be passed from the route config
    // on the data property
    const expectedRole = route.data.role;

    // decode the token to get its payload
    var tokenPayload = this.auth.decodeToken();
    var tokenRoles = [];
    if (tokenPayload == undefined){
      this.router.navigate(['invalid_page']);
      return false;
    }
    else if (tokenPayload.role) {
      if (tokenPayload.role.constructor !== Array) {
        tokenRoles.push(tokenPayload.role);
      }
      else {
        tokenRoles = tokenPayload.role;
      }

      if (!this.auth.isAuthenticated() || !expectedRole.some(r => tokenRoles.indexOf(r) >= 0)) {
        this.router.navigate(['dashboard']);
        return false;
      }
      return true;
    }
    else {
      this.router.navigate(['invalid_page']);
      return false;
    }
  }
}


// WEBPACK FOOTER //
// /Users/muhammadfiqihfirdiansyah/Documents/Muhammad Fiqih Firdiansyah/Project/Angular/BODES/BODES.Web.UI.Angular4/src/app/auth/role-guard.service.ts